export var FlowState;
(function (FlowState) {
    FlowState["Active"] = "Active";
    FlowState["Inactive"] = "Inactive";
    FlowState["SoftDeleted"] = "SoftDeleted";
})(FlowState || (FlowState = {}));
export var FlowKind;
(function (FlowKind) {
    FlowKind["Base"] = "Base";
    FlowKind["Skill"] = "Skill";
    FlowKind["FlowTemplate"] = "FlowTemplate";
})(FlowKind || (FlowKind = {}));
//# sourceMappingURL=enums.js.map